// utils/TransactionUtil.jsx
import { axiosInstance } from "config/axiosConfig";

// 공통 요청 함수 (GET/POST 분기 처리)
async function requestData(method, url = "", params = {}, noLoading = false, timeout = 3000) {
    if(!noLoading) await new Promise((r) => setTimeout(r, 500)); // 의도적 지연

    try {
        const config = {
            method,
            url,
            noLoading,
            timeout,
            ...(method === "get" ? { params } : { data: params }) // GET과 POST 구분
        };

        const response = await axiosInstance(config);

        if (response.status === 200) {
            return response.data;
        } else {
            console.error(`오류 발생: 상태 코드 ${response.status}`);
            throw new Error(response.statusText || "Unexpected error occurred");
        }
    } catch (error) {
        console.error(`HTTP ${method.toUpperCase()} 요청 실패:`, error);
        throw error;
    }
}

// GET 요청
export async function getData(url = "", params = {}, noLoading = false, timeout = 3000) {
    return requestData("get", url, params, noLoading, timeout);
}

// POST 요청
export async function postData(url = "", params = {}, noLoading = false, timeout = 10000) {
    return requestData("post", url, params, noLoading, timeout);
}

